var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgStarOff = function SvgStarOff(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M3.53 2.47a.75.75 0 0 0-1.06 1.06l5.085 5.086-4.169.641a.75.75 0 0 0-.423 1.265l3.986 4.082-.942 5.775a.75.75 0 0 0 1.103.777L12 18.452l4.89 2.704a.75.75 0 0 0 1.103-.777l-.258-1.583 2.735 2.734a.75.75 0 1 0 1.06-1.06l-18-18ZM15.92 16.98 8.87 9.93l-3.815.587 3.23 3.309a.75.75 0 0 1 .204.645l-.754 4.624 3.901-2.157a.75.75 0 0 1 .726 0l3.901 2.157-.345-2.116Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "m18.944 10.518-2.127 2.178 1.061 1.06 3.159-3.234a.75.75 0 0 0-.423-1.265l-5.479-.842L12.68 3.18a.75.75 0 0 0-1.358 0l-1.284 2.735 1.128 1.128L12 5.265l1.947 4.149a.75.75 0 0 0 .565.423l4.432.68Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStarOff);
export default ForwardRef;